// extracted by mini-css-extract-plugin
module.exports = {"selector":"Selector_selector__3YvaQ","label":"Selector_label__2eV8t","showMenuButton":"Selector_showMenuButton__gbbDS"};